export class LienItemModel {
  iconClass?: string;
  libelle: string;
  routerLink: string;
  isOutsideLink? = false;
}
